import { EMPTY, timer } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { Util } from './../_classes/util';
import { tap, take, catchError } from 'rxjs/operators';
import { Dependencia } from './../_classes/dependencia';
import { Observable, Subject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-dependente',
  templateUrl: './dependente.component.html',
  styleUrls: ['./dependente.component.scss'],
})
export class DependenteComponent implements OnInit {
  private readonly recurso: string = 'dependente'; //mesmo que a rota
  carregando = false;

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<Dependencia[]>;
  dataSource: MatTableDataSource<Dependencia>;

  listaItens: Array<string> = new Array<string>();
  listaClasse: Array<string> = new Array<string>();

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private env: EnvService
  ) {
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit() {
    this.atualizar();
  }

  formatarData(dI: Date, dF: Date): string {
    return Util.periodoMesAbreviado(dI, dF);
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }*/

  executarAoCarregarDataSource(x: Dependencia[]) {
    this.dataSource = new MatTableDataSource<Dependencia>(x);
    this.listaItens = x
      .map((item) => item.tipoDependencia.dsTipoDependencia)
      .filter((value, index, self) => self.indexOf(value) === index);

    this.listaItens.forEach((x) => {
      let item = Util.estiloRandomico(this.listaClasse);
      this.listaClasse.push(item);
    });

    this.carregando = false;
  }

  cor(se: Dependencia) {
    return (
      'badge ' +
      this.listaClasse[
        this.listaItens.indexOf(se.tipoDependencia.dsTipoDependencia)
      ]
    );
  }

  atualizar() {
    this.carregando = true;

    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    this.dataSource$ = this.service
      .listarDependencia(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDataSource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }
  /*
  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    this.servidor =
      this.servService.getServidorAtualRedirecionando('dependente');

    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return empty();
      })
    );

    if (this.servidor) {
      this.dataSource$ = this.service
        .listarDependencia(this.servidor.idServidor)
        .pipe(
          tap((a) => this.executarAoCarregarDataSource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return empty();
          })
        );
    }
  }*/

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
